import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";
import ProductPickupPointDecorator from "./ProductPickupPointDecorator";

export default class ProductOrderFieldPickupPointOptionDecorator extends BaseDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      product_pickup_point: data.product_pickup_point && new ProductPickupPointDecorator(data.product_pickup_point),
    });
  }

  get name() {
    if (this.pickup_point_type == "predefined") {
      return this.product_pickup_point.location_name;
    } else if (this.pickup_point_type == "undefined") {
      return I18n.t("activerecord.attributes.product_order_field.undefined_pickup_point_option_name");
    } else if (this.pickup_point_type == "custom") {
      return I18n.t("activerecord.attributes.product_order_field.custom_pickup_point_option_name");
    }
  }

  display_name_with_price(field) {
    const price = this.display_price(field);
    return price ? `${this.name} (${price})` : this.name;
  }

  display_price(field) {
    if (!this.price || !this.price.value) {
      return;
    }
    const price = st.formatMoney(this.price);
    const label = field.price_label;
    return [price, label].filter((x) => !!x).join(" ");
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductOrderFieldPickupPointOptionDecorator.js